// extracted by mini-css-extract-plugin
export var currencyInput = "_jh-1";
export var currencySymbol = "_jh-0";